import {createAction} from '@reduxjs/toolkit';

export const updateThreadToastStatus = createAction<{status: boolean}>('threads/actions/updateThreadToastStatus');
